/**
 * `meta` запиту TanStack Query. `quiet` — збій запиту не йде в журнал «останніх помилок» звернення
 * (UX-51): запит лише уточнює типові значення, людина збою не бачить (`QueryCache.onError`, main.tsx).
 */
export const QUIET = { quiet: true } as const;

/** `QueryCache.onError`: чи писати збій у журнал. */
export function isQuiet(meta: Record<string, unknown> | undefined): boolean {
  return meta?.quiet === true;
}
